import _styled, { default as _styled2 } from "styled-components";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import { priceFormatter } from '@noths/polaris-client-utils';
import * as styles from "./Price.styles";
export var Price = function Price(_ref) {
  var currency = _ref.currency,
    price = _ref.price;
  if (!price || !currency) {
    return null;
  }
  var isNegative = Boolean(price < 0);
  return /*#__PURE__*/React.createElement(_StyledSpan, {
    $_css: styles.priceModifier
  }, /*#__PURE__*/React.createElement(_StyledSpan2, {
    "data-is-negative": isNegative,
    $_css2: styles.priceOperator
  }, isNegative ? /*#__PURE__*/React.createElement(React.Fragment, null, "\u2212") : /*#__PURE__*/React.createElement(React.Fragment, null, "+")), /*#__PURE__*/React.createElement("span", null, priceFormatter(currency, price).replace('-', '')));
};
var _StyledSpan = _styled("span")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledSpan2 = /*#__PURE__*/_styled2("span").withConfig({
  displayName: "Price___StyledSpan2",
  componentId: "sc-1h404d7-0"
})(["", ""], function (p) {
  return p.$_css2;
});